// extracted by mini-css-extract-plugin
module.exports = {"listBlock":"styles_listBlock__OQlmo","description":"styles_description__6gVF2","list":"styles_list__gcOZn","listItem":"styles_listItem__c7KBe"};